<route>
{
  "meta": {
    "permission": [
      "expenses.view_expense"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      :title="$tc('expenses_recurring', 2)"
      :headers="headers"
      app="expenses.expense"
      api="expense"
      @click:create="changeRoute({ pk: 'create' })"
      @click:edit="changeRoute"
      :opt="{ recurrent: true }"
    >
      <template v-slot:item.date="{ item }">
        <span v-text="dateFormat(item.date)"></span>
      </template>
      <template v-slot:item.next_date="{ item }">
        <span v-text="dateFormat(item.next_date)"></span>
      </template>
      <template v-slot:item.start_date="{ item }">
        <span v-text="dateFormat(item.start_date)"></span>
      </template>
      <template v-slot:item.recurrent_start_date="{ item }">
        <span v-text="dateFormat(item.recurrent_start_date)"></span>
      </template>

      <template v-slot:deleteBtn="{ item, remove }">
        <i-btn
          :title="$tc('delete', 1)"
          outlined
          classes="mx-1"
          icon="fa-trash"
          color="error"
          @click="customRemove(item, remove)"
        />
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    headers() {
      return [
        {
          text: this.expenseBtn.category ? this.$tc('category', 1) : '',
          value: this.expenseBtn.category ? 'category.name' : ''
        },
        {
          text: this.expenseBtn.account ? this.$t('account') : '',
          value: this.expenseBtn.account ? 'account.name' : ''
        },
        {
          text: this.$tc('start_date', 2),
          value: 'start_date'
        },
        {
          text: this.$t('description'),
          value: 'description'
        },

        {
          text: this.$t('recurrent_start_date'),
          value: 'recurrent_start_date'
        },
        {
          text: this.$t('next_date'),
          value: 'next_date'
        },
        {
          text:
            this.expenseBtn.delete || this.expenseBtn.edit
              ? this.$t('action')
              : '',
          value: this.expenseBtn.delete || this.expenseBtn.edit ? 'actions' : ''
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    expenseBtn() {
      return {
        delete:
          this.getPermissions([`expenses.delete_expense`]) || this.isAdmin,
        edit: this.getPermissions([`expenses.change_expense`]) || this.isAdmin,
        account: this.getPermissions([`expenses.view_account`]) || this.isAdmin,
        category:
          this.getPermissions([`expenses.view_category`]) || this.isAdmin
      }
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    changeRoute(item) {
      this.$router.push({
        name: 'expensesRecurring-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    },
    customRemove(item, defaultRemove) {
      this.showConfirmation({
        show: true,
        model: this.$tc('expenses_recurring', 2),
        title: this.$tc('delete', 1),
        type: 'error white--text',
        content:
          'Si elimina el registro, se borrarán también los eventos del calendario y la campana.',
        alert: `${this.$t('success', {
          model: this.$tc('expenses_recurring', 2),
          action: this.$tc('delete', 2)
        })}`,
        confirm: () => {
          this.$api.expense.remove({ pk: item.pk }).then(() => {
            this.$store.dispatch(
              'confirmation/confirmationFinished',
              this.$tc('expenses_recurring', 2)
            )
            this.$root.$emit('payment-processed')
          })
        }
      })
    }
  }
}
</script>
